import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeMedicalComponent } from './home-medical/home-medical.component';
import { MedicalAppointmentComponent } from './medical-appointment.component';
import { RequestAppointmentComponent } from './request-appointment/request-appointment.component';
import { ConsultMedicalAppointmentComponent } from './consult-medical-appointment/consult-medical-appointment.component';
import { AuthGuardService } from '../../shared/security/auth-guard.service';
import { PaymentAppointmentComponent } from './payment-appointment/payment-appointment/payment-appointment.component';

const medicalAppointmentRoutes: Routes = [
    {
      path: '',
      component: MedicalAppointmentComponent,
      children: [
        {
          path: '',
          children: [
            { path: 'home', component: HomeMedicalComponent,  canActivate: [AuthGuardService] },
            { path: 'request', component: RequestAppointmentComponent,  canActivate: [AuthGuardService]},
            { path: 'consult', component: ConsultMedicalAppointmentComponent,  canActivate: [AuthGuardService]},
            { path: 'payment', component: PaymentAppointmentComponent,  canActivate: [AuthGuardService]},
            { path: '', component: HomeMedicalComponent,  canActivate: [AuthGuardService] }
          ]
        }
      ]
    }
  ];
  
  @NgModule({
    imports: [
      RouterModule.forChild(medicalAppointmentRoutes)
    ],
    exports: [
      RouterModule
    ]
  })
  export class MedicalAppointmentRoutingModule {}


// WEBPACK FOOTER //
// /app/src/app/office/medical-appointment/medical-appointment-routing.module.ts